import Link from 'next/link';

import { useServicesLinkClick } from '../../../../../../shared';
import type { NavLinkModel } from '../../../../../../types';

import './overview-link.scss';

type OverviewLinkProps = {
    link: NavLinkModel;
    onSelect: () => void;
};

export function OverviewLink({ link, onSelect }: OverviewLinkProps) {
    const handleServicesLinkClick = useServicesLinkClick();

    return (
        <Link
            href={link.href}
            className="mobile-menu-overview-link"
            rel={link.openInNewTab ? 'noopener noreferrer' : undefined}
            target={link.openInNewTab ? '_blank' : undefined}
            onClick={event => {
                handleServicesLinkClick({
                    event,
                    link: link.href,
                    shouldOpenInNewTab: link.openInNewTab,
                });
                onSelect();
            }}
        >
            {link.label}
        </Link>
    );
}
